import React from 'react';
import PropTypes from 'prop-types';
import StaffCanvasAccessRow from './StaffCanvasAccessRow';

/**
 * Wires stable row-level callbacks using the row locationKey.
 */
const StaffCanvasAccessRowContainer = ({
  row,
  editingLocationKey = null,
  roleOptionsByLocation,
  rowActionsDisabled,
  rolesLoadingLocationKey = null,
  submitting,
  bulkApi = null,
  onLoadRolesForLocation,
  onStartRowEdit,
  onCancelRowEdit,
  onSaveRowEdit,
  onToggleRowSelected,
  onRowDraftRoleChange,
  onRequestRemoveRowAccess = null,
}) => {
  const locationKey = row.locationKey;

  return (
    <StaffCanvasAccessRow
      row={row}
      editingLocationKey={editingLocationKey}
      roleOptionsByLocation={roleOptionsByLocation}
      rowActionsDisabled={rowActionsDisabled}
      draftRoleId={bulkApi?.getRowDraftRole(locationKey)}
      isSelected={bulkApi?.isLocationSelected(locationKey) ?? false}
      isLoadingRoles={rolesLoadingLocationKey === locationKey}
      submitting={submitting}
      onToggleSelected={() => onToggleRowSelected(locationKey)}
      onLoadRoles={() => onLoadRolesForLocation(locationKey)}
      onDraftRoleChange={(event) => onRowDraftRoleChange(locationKey, event.target.value)}
      onStartEdit={() => onStartRowEdit(locationKey, row.canvasRoleId)}
      onCancelEdit={onCancelRowEdit}
      onSaveEdit={() => onSaveRowEdit(locationKey)}
      onRemoveAccess={
        onRequestRemoveRowAccess ? () => onRequestRemoveRowAccess(row) : null
      }
    />
  );
};

StaffCanvasAccessRowContainer.propTypes = {
  row: PropTypes.shape({
    locationKey: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    locationName: PropTypes.string,
    canvasAccountId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    canvasRoleId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    canvasRoleLabel: PropTypes.string,
    provisioned: PropTypes.bool,
  }).isRequired,
  editingLocationKey: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  roleOptionsByLocation: PropTypes.object.isRequired,
  rowActionsDisabled: PropTypes.bool.isRequired,
  rolesLoadingLocationKey: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  submitting: PropTypes.bool.isRequired,
  bulkApi: PropTypes.object,
  onLoadRolesForLocation: PropTypes.func.isRequired,
  onStartRowEdit: PropTypes.func.isRequired,
  onCancelRowEdit: PropTypes.func.isRequired,
  onSaveRowEdit: PropTypes.func.isRequired,
  onToggleRowSelected: PropTypes.func.isRequired,
  onRowDraftRoleChange: PropTypes.func.isRequired,
  onRequestRemoveRowAccess: PropTypes.func,
};

export default StaffCanvasAccessRowContainer;
